import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useMaintenanceEstablishmentChoiceAuctionEntryProposalsAccept } from "@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/hooks/useMaintenanceEstablishmentChoiceAuctionEntryProposalsAccept";
import { MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryProposalData } from "@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/types/updatedSummary.type";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface AcceptProposalProps {
  proposal: MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryProposalData | null;
  onDismiss: () => void;
}

const AcceptProposal = ({
  proposal,
  onDismiss,
}: AcceptProposalProps) => {
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const queryClient = useQueryClient();

  const {
    mutate: acceptProposal,
    isPending: acceptProposalIsPending,
  } = useMaintenanceEstablishmentChoiceAuctionEntryProposalsAccept({
    proposalId: proposal?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding'],
        });

        queryClient.invalidateQueries({
          queryKey: ['maintenanceEstablishmentChoiceAuctionEntryUpdatedSummary'],
        });

        onDismiss();
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      },
    },
  });

  return (
    <>
      <Modal
        isOpen={!!proposal}
        setIsOpen={(value) => {
          if (!value) {
            onDismiss();
          }
        }}
        title="Aceitar proposta"
        titleClass="text-2xl"
        useCancellableFooter
        cancelButtonClassName="bg-white-200"
        bodyClassName="text-white-800"
        confirmButtonText="Aceitar"
        confirmButtonIsLoading={acceptProposalIsPending}
        onConfirm={() => acceptProposal()}
        body={(
          <div className="flex flex-col gap-3">
            <p className="text-base font-bold">
              Deseja aceitar a proposta de {proposal?.establishment_fantasy_name || 'este estabelecimento'}?
            </p>

            <p className="text-sm">
              Ao aceitar, o leilão será encerrado e este estabelecimento será escolhido como vencedor.
            </p>
          </div>
        )}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default AcceptProposal;
